<vcl-dialog [showDialog]="navigationService.loadExitScreen" [buttonLabels]="copyService.copies.header_exit_button" [dialogTitle]="copyService.copies.header_exit_button.title" (dialogButtonClick)="clickTwoLinkOnb($event)" [id]="'dialogClose'" [buttonAlignment]="'horizontal'">
  <p id="dialogDescription">
    {{ copyService.copies.header_exit_button.description }}
  </p>
</vcl-dialog>
<div class="content-without-stepper-and-title">
    <div class="row">
      <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
        <div *ngIf="close" class="portal-header-link">
          <p id="headerCloseText" class="link" (click)="showClose()">{{copyService.copies.header_close}}</p>
          <span id="headerCloseText" (click)="showClose()" class="icon-itaufonts_fechar"></span>
        </div>
        <div class="wrap">
          <div class="img-container">
            <img [id]="'errorImage'" [src]="errorInfo.image" alt="Imágen del error"  width="200" height="200"/>
          </div>
  
          <div>
            <h1 class="title"  id="title" *ngIf="errorInfo.title" [innerHtml]="errorInfo.title"></h1>
            <ul>
              <vcl-list>
                <li *ngFor="let item of items" vclListSimple>
                  <vcl-list-text>
                    {{item.name}}
                  </vcl-list-text>
                </li>
              </vcl-list>
            </ul>
          </div>
          <p class="description" id="description"  [innerHtml]="errorInfo.description"></p>
        </div>
      </div>
    </div>
    <div *ngIf="errorInfo">
      <app-controls id="errorBtns" [hasPrevious]="true" [nextLabel]="errorInfo.buttonLabel" (next)="next()"></app-controls>
    </div>
  </div>